import Icon from '@/root/ui/shared/Icon'
import { IconProps } from '@/root/shared-types/ui/ui-types'
import { FC } from 'react'

export const BookTicketIcon: FC<IconProps> = ({ width = 37, height = 37, ...rest }) => (
  <Icon type="BookTicket" width={width} height={height} alt="iconBookTicket" ignoreRtl {...rest} />
)
